import styled from 'styled-components';

const CustomLinkContainer = styled.div`
  display: flex;
  align-items: center;
`;

export {CustomLinkContainer};
